// extracted by mini-css-extract-plugin
export var entityChip = "_th-0";
export var entityChipMissing = "_th-1";